let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eGYWN")).then(() => parcelRequire('jjqbH'));